import { localeService } from '#/client/api';
import { Locale } from '#/client/models';
import { StorageKeys } from '#/service/constants';

const fallbackLanguage: Locale = {
  code: 'en',
  endonym: 'English',
  exonym: 'English',
  fallback: true,
};

/**
 * Fetches list of supported locales. In case there is problem with the request then
 * a fallback response is returned to make sure English language will be working fine
 **/
export const fetchLocales = async () => {
  try {
    const res = await localeService.getLocales();

    return res.data?.locales ?? [fallbackLanguage];
  } catch {
    return [fallbackLanguage];
  }
};

export const fetchLocale = async (locale: string) =>
  localeService
    .getTranslation(locale)
    .then((result) => {
      const { data: { translations } = {} } = result;

      if (!translations) {
        console.error(`Locale ${locale} does not exist.`);

        return;
      }

      return translations;
    })
    .catch(() =>
      console.error(`There was an error fetching locale: ${locale}.`)
    );

// Normalizing locale. For example en_US -> en-US
// Feel free to expand on this in the future, for now it's relatively simple
const normalizeLocale = (locale: string) =>
  locale.replaceAll('_', '-').toLowerCase().split('-')[0];

export const getClientLocale = () => {
  const storageLocale = localStorage.getItem(StorageKeys.LOCALE);

  return storageLocale ?? normalizeLocale(navigator.language);
};

export const detectLocale = (locales: Locale[]) => {
  const userLocale = getClientLocale();
  const coreLocale = locales.find((locale) => locale.code === userLocale);

  return (
    coreLocale || locales.find((locale) => !!locale.fallback) || locales[0]
  );
};
